import { api } from './client';

/**
 * Indique e Ganhe — `/api/v1/referral/*`.
 *
 * Indicado ganha `welcome_brl` em cashback depois do 1º aporte feito após
 * aplicar o código; indicador ganha `referrer_percent`% em cashback de cada
 * recarga do indicado paga com saldo durante `window_days` (a partir da 1ª
 * recarga paga dele). Valores vêm do backend (regra versionada) — nunca
 * hardcodar no front.
 */

export type ReferralStatus = 'claimed' | 'topped_up' | 'earning' | 'expired';

export interface ReferralItemOut {
  /** Só o 1º nome do indicado (LGPD). */
  first_name: string;
  status: ReferralStatus;
  claimed_at: string;
  /** Quanto este indicado já rendeu pro indicador (decimal string). */
  earned_brl: string;
  /** Dias restantes da janela — só quando `earning`. */
  days_left: number | null;
}

export interface ReferralStatsOut {
  claimed: number;
  topped_up: number;
  earning: number;
  earned_brl: string;
}

export interface ReferralMeOut {
  /** false = programa desligado (kill-switch) → o app esconde tudo. */
  enabled: boolean;
  code: string | null;
  link: string | null;
  welcome_brl: string;
  /** Já formatado pra exibir: "5", "7.5", "10". */
  referrer_percent: string;
  window_days: number;
  inactive_days: number;
  stats: ReferralStatsOut;
  referrals: ReferralItemOut[];
}

export interface ReferralClaimOut {
  referral_id: string;
  welcome_brl: string;
  referrer_first_name: string;
}

export interface ReferralCodeOut {
  valid: boolean;
  referrer_first_name: string | null;
  welcome_brl: string | null;
  referrer_percent: string | null;
  window_days: number | null;
}

export const referralApi = {
  me: () => api.get<ReferralMeOut>('/referral/me'),
  claim: (code: string) => api.post<ReferralClaimOut>('/referral/claim', { code }),
  /** Público (sem auth) — landing `/convite/:code`. */
  lookup: (code: string) =>
    api.get<ReferralCodeOut>(`/referral/codes/${encodeURIComponent(code)}`)
};

/** Rótulo de cada etapa, na voz do indicador ("Maria · Fez o 1º aporte"). */
export function referralStatusLabel(item: Pick<ReferralItemOut, 'status' | 'days_left'>): string {
  switch (item.status) {
    case 'claimed':
      return 'Cadastrou com seu código';
    case 'topped_up':
      return 'Fez o 1º aporte';
    case 'earning':
      return item.days_left != null && item.days_left > 0
        ? `Rendendo · faltam ${item.days_left} dias`
        : 'Rendendo';
    case 'expired':
      return 'Janela encerrada';
    default:
      return item.status;
  }
}
